import { useChargingStationDetails } from '../useChargingStationDetails';
import { RefetchOnError, NoGeneralDetails } from '@energy-stacks/shared';
import { ChargingStationGeneralDetailsV201 } from './ChargingStationGeneralDetailsV201';

export const ChargingStationDetailsGeneralTabV201 = () => {
  const { chargingStationDetails, isSuccess, isError, refetch } =
    useChargingStationDetails();

  return (
    <>
      {isError ? <RefetchOnError onRefetch={refetch} /> : null}
      {!chargingStationDetails && isSuccess ? (
        <NoGeneralDetails onRefetch={refetch} />
      ) : (
        <ChargingStationGeneralDetailsV201 />
      )}
    </>
  );
};
